   /**
   * Function to get the most popular car categories based on the cars data.
   * @param {Array} cars - The array of car objects.
   * @returns {Array} - An array of the top 6 categories with their count, image, and index.
   */

 export const getPopularCarCategories = (cars) => {

    const categoryCount = {}; // Object to store the count of each car type
    const categoryImage = {}; // Object to store an image for each car type

    // Count occurrences of each carType and store an image
    cars.forEach((car) => {
        const category = car.details.carType; // Get the car type (category)
        categoryCount[category] = (categoryCount[category] || 0) + 1; // Increment count for the category
        if (!categoryImage[category]) categoryImage[category] = car.image; // Store first car's image
    });

    // Convert to an array, sort by count (descending), and take the top 6
    return Object.entries(categoryCount)
      .sort((a, b) => b[1] - a[1])
      .map(([category, count], index) => ({
          index: index + 1, // Add index (1-based)
          category,
          count,
          image: categoryImage[category],
      }));
  };